// This component is the navigation actions for the forms engine (next, archive, close)
import { useEffect, useState } from 'react'
import { FoundationsRequest, getBaseUrl, getUrlVars } from '../../Utils'
import { useFormEngineContext } from './formContext'
import { formHelp } from './formHelpers'
import moment from 'moment'
import { setCookie } from '../../GlobalMethods'
import { FormActionKind } from './formReducer'
import HandleAnyPopupMessage from '../../Components/handleAnyPopupMessage'
import { set } from 'react-hook-form'
declare let window: any

interface actionProps {
    showEditBtn: boolean
    index: number
    drillThruObj: { [s: string]: any }
    setTabGuid: (arg0: string) => void
    setDrillThruObj: (arg0: { [s: string]: any }) => void
    setPrintedOn: (arg0: string) => void
}

export const ActionsSection = (props: actionProps) => {
    const { showEditBtn, index, drillThruObj, setTabGuid, setDrillThruObj, setPrintedOn } = props
    const { formState, formDispatch } = useFormEngineContext()
    const formName = getUrlVars()['formName']
    // const metaData= formState.MetaDataMap ? formState.MetaDataMap[formState.templateType || ''] : {}
    const [status, setStatus] = useState(formHelp.INCOMPLETE)
    const [showPopupMessage, setShowPopupMessage] = useState(false)
    const [popupTitle, setPopupTitle] = useState('')
    const [popupMessage, setPopupMessage] = useState('')
    const [hidePopupClose, setHidePopupClose] = useState(false)
    const [closeAfterSecs, setCloseAfterSecs] = useState(-1 as number | undefined)
    const [customPopupButtons, setCustomPopupButtons] = useState(
        [] as { text: string; onClick: () => void }[]
    )
    const setPopUpInfo = (
        title: string,
        message: string,
        hideClose: boolean,
        timer: number,
        buttons: { text: string; onClick: () => void }[]
    ) => {
        setPopupTitle(title)
        setPopupMessage(message)
        setHidePopupClose(hideClose)
        setCloseAfterSecs(timer)
        setCustomPopupButtons(buttons)
    }
    const sectionStatus = (section: {
        sectionGroups: any
        name: string | string[]
        instances: any
    }) => {
        return formHelp.isValidSection(section) ? formHelp.COMPLETED : formHelp.INCOMPLETE
    }

    //  definition = schema.sections[index],
    // const definition = formState.schema.sections.find(function (section: { formId: any }) {
    //     return section.formId === index + 1
    // })

    useEffect(() => {
        const section = formState.schema?.sections[index]
        // TODO cleanup coe here
        // const fieldset = section?.instances
        // const onceOnly = definition.onceOnly
        // formHelp.addMissingField(definition?.instances[0], fieldset, onceOnly)
        if (section !== undefined) setStatus(sectionStatus(section))
    }, [formState.schema])

    // TODO verify if any forms still use the multiple/allowSayno fields
    // multiple = definition.multiple,
    // allowSayNo = index === 2 || index === 9,

    const toggleReadOnly = () => {
        let postFormObj = {
            dataObjectId: formState.dataObjectId,
            IsReadOnly: !formState.isReadOnly,
            formName: formName,
            formType: formState.templateType,
        }

        FoundationsRequest('POST', {
            url: getBaseUrl() + 'API/v3/FORMENGINE/ToogleReadOnly',
            // TODO is config needed here?
            // config: function (xhr: any) {},
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            includeTokenHeader: true,
            data: JSON.stringify(postFormObj),
            success: function (response: { statusCode: number; statusMessage: string }) {
                try {
                    if (response.statusCode === 200) {
                        formHelp.checkandremove_Issingletoncookies(formName, formState.dataObjectId) //FP-5973 Adding call to remove singelton info from cookies before close or refresh the page.
                        // location.reload()
                        formDispatch({
                            type: FormActionKind.setIsReadOnly,
                            payload: postFormObj.IsReadOnly,
                        })
                    } else {
                        console.error(
                            '*ERR* Failed to update FORMENGINE/ToogleReadOnly ' +
                                response.statusMessage
                        )
                    }
                } catch (e) {
                    console.error('*ERR* Toggle Form ReadOnly Failed - Exp' + e)
                }
            },
        })
    }
    return (
        <div id="formActionsSection">
            {formState.schema !== undefined && Object.keys(formState.schema).length > 0 ? (
                <div className=" row pl-3 pr-3 mb-4">
                    <div
                        className=" col-12 card currentstatus darken"
                        style={{
                            backgroundColor: formState.schema.titleBgColor,
                        }}
                    >
                        <h3>
                            {formState.schema.feature}
                            {formHelp.StatusLabel(status)}
                        </h3>
                    </div>
                    <div
                        id="lockedStatus"
                        className="col-12 px-0 mt-0 mb-3"
                        style={
                            formState.isReadOnly || !formState.lockedStatus
                                ? { color: 'red' }
                                : { color: 'green' }
                        }
                    >
                        {formState.lockedStatusMsg}
                    </div>
                    <div className="col-12">
                        <div className="d-flex flex-row justify-content-start">
                            <div id="unlockBtn" className="w-100 d-none">
                                <a
                                    className="statusButton"
                                    onClick={() => {
                                        let tabGuid = formState.guid
                                        setCookie('drillthrudata_' + tabGuid, '', -15)
                                        formHelp.unlockForm(
                                            formName,
                                            formState.dataObjectId,
                                            formState.isNavigationEnabled,
                                            !!formState.isCopyPasted,
                                            'YES',
                                            drillThruObj,
                                            setTabGuid,
                                            setDrillThruObj,
                                            setPopUpInfo,
                                            setShowPopupMessage
                                        )
                                    }}
                                >
                                    <span className="label button mr-2 ml-0">Unlock</span>
                                </a>
                            </div>
                            {!formState.isCopyPasted ? (
                                <>
                                    {formState.isNavigationEnabled == 'true' ? (
                                        <div id="nextBtn" className="w-100">
                                            <a
                                                className="statusButton"
                                                onClick={() => {
                                                    setPopUpInfo(
                                                        'Form Navigation Alert',
                                                        'Searching for next available form.',
                                                        false,
                                                        -1,
                                                        []
                                                    )
                                                    setShowPopupMessage(true)

                                                    formHelp.unlockForm(
                                                        formName,
                                                        formState.dataObjectId,
                                                        formState.isNavigationEnabled,
                                                        !!formState.isCopyPasted,
                                                        'No',
                                                        drillThruObj,
                                                        setTabGuid,
                                                        setDrillThruObj,
                                                        setPopUpInfo,
                                                        setShowPopupMessage
                                                    )
                                                }}
                                            >
                                                <span className="label app-button mr-2 ml-0">
                                                    Next
                                                </span>
                                            </a>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    <div id="closeBtn" className="w-100">
                                        <a
                                            className="statusButton"
                                            onClick={() => {
                                                formHelp.unlockForm(
                                                    formName,
                                                    formState.dataObjectId,
                                                    formState.isNavigationEnabled,
                                                    !!formState.isCopyPasted,
                                                    'YES',
                                                    drillThruObj,
                                                    setTabGuid,
                                                    setDrillThruObj,
                                                    setPopUpInfo,
                                                    setShowPopupMessage
                                                )
                                            }}
                                        >
                                            <span className="label app-button mr-2 ml-0">
                                                Close
                                            </span>
                                        </a>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}
                            <div id="printBtn" className="w-100">
                                <a
                                    className="statusButton"
                                    onClick={() => {
                                        setPrintedOn(
                                            moment(Date.now()).format('MM/DD/YYYY hh:mm A')
                                        )
                                        window.print()
                                    }}
                                >
                                    <span className="label app-button mr-2 ml-0">Print</span>
                                </a>
                            </div>
                            {(!formState.lockedData?.isGlobal ||
                                formState.lockedData?.formLocked) &&
                            showEditBtn ? (
                                <div id="toggleEditBtn" className="w-100">
                                    <a
                                        className="statusButton"
                                        onClick={() => {
                                            toggleReadOnly()
                                        }}
                                    >
                                        <span className="label app-button mr-2 ml-0">
                                            {formState.isReadOnly ? 'Unarchive' : 'Archive'}
                                        </span>
                                    </a>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                    <HandleAnyPopupMessage
                        isOpen={showPopupMessage}
                        title={popupTitle}
                        message={popupMessage}
                        onClose={() => setShowPopupMessage(false)}
                        closeAfterSecs={closeAfterSecs}
                        Link={null}
                        linkText=""
                        customButtons={customPopupButtons}
                        hideClose={hidePopupClose}
                    />
                </div>
            ) : (
                <></>
            )}
        </div>
    )
}
